<template>
    <section  class="w-100 footer">
            <div class="mt-5 row justify-content-center align-items-center">
                <div class="col-12">
                    <h3>Great Alliance Financial Advisers ltd</h3>
                </div>                
                <div class="col-10 col-md-4">
                    <hr>
                </div>
            </div>            
            <div style="margin-top:20px;" class="row">
                <div class="col-5">
                    <p><i class="fas fa-map-marker-alt"></i> Unit 9, 51 William Pickering Drive</p>
                    <p>Auckland</p>
                    <p>0632</p>
                    <p>New Zealand</p>
                </div>
                <div class="col-5">
                    <p><i class="fas fa-phone-alt"></i> 09 3937977</p>
                    <p><i class="fas fa-envelope"></i> melissa@gafa.co.nz</p>
                </div>
                <div class="col-2">
                    <p>Follow Us</p>
                    <nav class="navbar">
                        <form class="form-inline">
                            <a href="https://www.facebook.com/GAFA-100448601379559/"><i class="fab fa-facebook"></i></a>
                            <a href="https://www.instagram.com/gafanewzealand/"><i class="fab fa-instagram"></i></a>
                        </form>
                    </nav>
                </div>
            </div>            
    </section>
</template>
<script>
export default {
    name:'Footer'
}
</script>

<style>
    .footer{
        padding: 0px 50px 20px 50px;
        margin-top: 0px;
        background-color: #282828;     
    }
    .footer p{
         margin-bottom: 0;
         color: whitesmoke;
    }
    .footer a{
        font-size: 4rem;
        margin-right:40px;
        color: whitesmoke;
        transition: all 0.6s;
    }
    .footer a:hover{
        color: #ff6666;
    }
    .footer h3{
        color: whitesmoke!important;
    }
    .footer hr{
        background-color: whitesmoke;
    }
</style>